import React from 'react'
import { useAuth } from '@/hooks/useAuth'
import { UserProfileHelper } from '@lura/shared'
import { PatientPage } from '@/pages/PatientPage'
import { AdminPatientPage } from '@/pages/AdminPatientPage'

export const PatientPageWrapper: React.FC = () => {
  const { user } = useAuth()

  // Show admin patient page for Study Admins, regular patient page for clinicians
  if (UserProfileHelper.isStudyAdmin(user)) {
    return <AdminPatientPage />
  }

  return <PatientPage />
}
